import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import {BaseApiTemplateService} from '../../shared/base-api-template-service.model';
import {Core2Config} from '../../shared/core2Config';
import { ConsolidatedArapAppletCatalogLinkContainerModel } from '../../../../../../models/aggregates/erp/index';

@Injectable({
    providedIn: 'root'
})
export class ConsolidatedArapAppletCatalogLinkService extends BaseApiTemplateService<ConsolidatedArapAppletCatalogLinkContainerModel> {
    
    readonly url = Core2Config.DOMAIN_TEST_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'consolidated-arap-applet-catalog-links/' + Core2Config.BACKOFFICE_EP_SUFFIX;

    constructor(http: HttpClient) {
        super();
        this.apiUrl = Core2Config.DOMAIN_TEST_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'consolidated-arap-applet-catalog-links/' + Core2Config.BACKOFFICE_EP_SUFFIX;
        this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'consolidated-arap-applet-catalog-links/' + Core2Config.BACKOFFICE_EP_SUFFIX;
        this.httpClient = http;
    }
    
}

